module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-f432f490cee1e3f0c9517402f1f3861c.svg";